export default __webpack_public_path__ + "static/media/celo_logo.e95fad7b.svg";